
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"currentColor"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.36 4.072a7.784 7.784 0 00-3.293-.736C3.26 3.336.488 7.769.16 8.292a2.412 2.412 0 01-.028.044.606.606 0 000 .667l.028.043c.152.244.834 1.334 2.004 2.43l1.06-.854a10.816 10.816 0 01-1.692-1.953c.667-1.066 3-4 6.534-4 .756 0 1.458.138 2.1.364l1.194-.96zm2.594 1.777l-1.061.855c.844.76 1.425 1.542 1.707 1.965-.667 1-3 4-6.533 4-.766 0-1.474-.14-2.122-.37l-1.192.959c.964.448 2.07.745 3.314.745 4.805 0 7.578-4.434 7.905-4.957L16 9.003a.606.606 0 000-.667 2.073 2.073 0 01-.028-.044c-.153-.244-.84-1.342-2.018-2.443zm-6.978 5.619c.338.13.705.201 1.09.201 1.667 0 3-1.333 3-3 0-.159-.012-.314-.035-.466L9.585 9.367a1.64 1.64 0 01-1.156.93l-1.453 1.17zm.686-4.418a1.64 1.64 0 00-1.096.883L5.1 9.114a3.072 3.072 0 01-.032-.445c0-1.666 1.333-3 3-3 .377 0 .738.069 1.07.194L7.661 7.05z"}}),_c('path',{attrs:{"d":"M12.902 3.809a.768.768 0 11.963 1.196L2.882 13.848a.768.768 0 01-.963-1.196l10.983-8.843z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    